import axios from 'axios'

import router from '../../src/router/index'

import Vue from 'vue'
import { api } from '../api'


const state = {
	loggedIn: false,
	// display login error msg
	loginStatus: '',
	licenseExpiration: null,
	licenseExpired: false,
	showModal: true,
	showLicenseWarning: false
}

const mutations = {
	'AUTH_REQUEST': (state) => {
		state.status = 'loading'
	},
	'AUTH_LOGIN': (state, payload) => {
		Object.keys(payload.data).forEach(key => {
			if (key === 'password') return
			state[key] = payload.data[key]
		})
		state.loggedIn = true
		state.loginStatus = 'success'

		// check if license expired
		if (!state.licenseExpiration || new Date(state.licenseExpiration) < new Date()) {
			state.licenseExpired = true
		}
	},
	'AUTH_ERROR': (state) => {
		state.loginStatus = 'error'
	},
	'AUTH_RESET': (state) => {
		state.loginStatus = ''
	},
	// after showing license modal once, disable modal and enable license warning
	'TOGGLE_MODAL': (state) => {
		state.showModal = !state.showModal
		state.showLicenseWarning = !state.showLicenseWarning
	},
	'TOGGLE_LICENSE_WARNING': (state) => {
		state.showLicenseWarning = !state.showLicenseWarning
	}
}

const getters = {
	isAuthenticated: state => !!state.token,
	authStatus: state => state.loginStatus,
	isLoggedIn: state => {
		return (state.loggedIn && state.loginStatus === 'success')
	},
	getLicenseExpiration: state => {
		return state.licenseExpiration
	},
	licenseExpired: state => {
		return state.licenseExpired
	},
	showModal: state => {
		return state.showModal
	},
	showLicenseWarning: state => {
		return state.showLicenseWarning
	}
}

const actions = {
	logout: ({ state }) => {
		let user = {
			pid: state.pid,
			username: state.Name
		}
		axios({ url: process.env.VUE_APP_ROOT_API + '/publicitycustomer/logout', data: user, method: 'POST' }).then(() => {
			// redirect to login; using window location replace to reload page in order to completely clear state,
			// as vue router seems to store route params (like 'consecutiveVisit' in this particular instance)
			window.location.replace(window.location.origin)
		}).catch(() => {
			// ignore server side error; goto login
			// redirect to login; using window location replace to reload page in order to completely clear state,
			// as vue router seems to store route params (like 'consecutiveVisit' in this particular instance)
			window.location.replace(window.location.origin)
		})
	},
	login: ({ commit }, user) => {
		// take user provided password, add salt, hash with sha256 and encode into base64
		user.password = Vue.CryptoJS.enc.Base64.stringify(Vue.CryptoJS.SHA256(user.password + process.env.VUE_APP_PC_SALT))
		axios({ url: process.env.VUE_APP_ROOT_API + '/publicitycustomer/login', data: user, method: 'POST' })
			.then((resp) => {
				// if response status is 200, continue to dashboard
				if (resp.status === 200 && !resp.data.error) {
					let creds = resp.data;
					// store customer credentials and login status
					commit('AUTH_LOGIN', creds)
					router.push({ name: 'Home' });
				} else {
					// set status of global auth object to error
					// as a side effect, also display error msg on screen
					commit('AUTH_ERROR')
				}
			})
			.catch(() => {
				commit('AUTH_ERROR')
			})
	},
	authReset: ({ commit }) => {
		return new Promise((resolve) => {
			commit('AUTH_RESET');
			resolve();
		})
	},
	checkToken: ({ commit }, data) => {
		return new Promise(resolve => {
			api.queryAPIServerPost(process.env.VUE_APP_ROOT_API + "/publicitycustomer/verifytoken", data, async response => {
				let res = response.data;
				if (res.error) {
					console.error('An error occured. Please try again later.');
					resolve({})
					return;
				}
				if (res.data) {
					commit('AUTH_LOGIN', res)
					router.push({ name: 'Home' });
				} else {
					commit('AUTH_ERROR')
				}
			})
		})
	},
	toggleModal: ({ commit }) => {
		commit('TOGGLE_MODAL')
	},
	toggleLicenseWarning: ({ commit }) => {
		commit('TOGGLE_LICENSE_WARNING')
	}
}

export default {
	state,
	mutations,
	getters,
	actions
}
